import { Navigate, useNavigate, useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

import {
  Avatar,
  ImagePromptCard,
  WaveBackgroundLayout,
} from "~/common/components";
import SuccessIcon from "~/common/components/layouts/SuccessIcon";
import { CONSULTATION_TYPES, isPatientActive } from "~/common/utils";
import { useGetCurrentPatient } from "~/patients/hooks";
import { ROUTES } from "~/patients/router";

export const ConsultationPartCompleted = () => {
  const navigate = useNavigate();
  const { data: user } = useGetCurrentPatient();
  const { consultationType } = useParams();
  const providerPictureSrc =
    user?.organization_patients[0].primary_provider?.profile_picture_path;
  const providerName =
    user?.organization_patients[0].primary_provider?.signature_name;

  if (isPatientActive(user?.organization_patients[0].status))
    return <Navigate to={ROUTES.notFound} />;

  const consultationTypeMessage: Record<string, Record<string, string>> = {
    [CONSULTATION_TYPES.screening]: {
      title: "Consultation request complete!",
      subtitle:
        "We are reviewing your request and will be in touch with you soon.",
    },
    [CONSULTATION_TYPES.intake]: {
      title: "Consultation part 1 completed!",
      subtitle:
        "Thank you for taking the time to complete part 1 of your consultation.",
      extraText: "I’m looking forward to meeting you!",
    },
  };

  const title = consultationTypeMessage[consultationType!].title;
  const subtitle = consultationTypeMessage[consultationType!].subtitle;
  const extraText = consultationTypeMessage[consultationType!]?.extraText;

  return (
    <WaveBackgroundLayout className="relative justify-center p-6">
      <ImagePromptCard
        title={title}
        subtitle={subtitle}
        content={
          <div className="flex flex-col gap-3 text-center text-base font-light leading-5 text-gray-70">
            <p>{extraText}</p>
            <span>{providerName}</span>
          </div>
        }
        handleContinue={() => navigate(ROUTES.leadPatientHome)}
        imageContainerClassName={twMerge(
          providerPictureSrc ? "bg-primary-30" : "bg-green-100",
        )}
        continueLabel="Go to Home"
      >
        {providerPictureSrc ? (
          <Avatar
            className="size-28 rounded-full"
            src={providerPictureSrc}
            alt="ProfilePicture"
          />
        ) : (
          <SuccessIcon className="w-full" />
        )}
      </ImagePromptCard>
    </WaveBackgroundLayout>
  );
};
